import React, { useState, useEffect } from "react";
import Resizer from "react-image-file-resizer";
import API_BASE_URL from "../config/api";
import { Form, Spinner } from "react-bootstrap"

const PersonalInfo = ({ userId }) => {
  const [formData, setFormData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    employeeID: "",
    dateOfBirth: "",
    gender: "",
    maritalStatus: "",
    nationality: "",
    religion: "",
    bloodGroup: "",
    nationalId: "",
    passportNumber: "",
    drivingLicenseNumber: "",
    phoneNumber: "",
    personalEmail: "",
    officialEmail: "",
    address: "",
    city: "",
    postalCode: "",
    jobTitle: "",
    department: "",
    saturation: "",
    status: "",
    profileImageUrl: "",
  });

  const [notification, setNotification] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [generalMaster, setGeneralMaster] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const requiredFields = [
    { name: "firstName", label: "First Name" },
    { name: "lastName", label: "Last Name" },
    { name: "employeeID", label: "Employee ID" },
    { name: "dateOfBirth", label: "Date of Birth" },
    { name: "gender", label: "Gender" },
    { name: "maritalStatus", label: "Marital Status" },
    { name: "nationality", label: "Nationality" },
    { name: "bloodGroup", label: "Blood Group" },
    { name: "nationalId", label: "National ID Number" },
  ];

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Employee/GetEmployeeDetails/${userId}`);
        if (response.ok) {
          const data = await response.json();
          setFormData({
            // Employee table
            id: data.id || "",
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            employeeID: data.employeeID || "",
            dateOfBirth: data.dateOfBirth ? data.dateOfBirth.split("T")[0] : "",
            gender: data.gender || "",
            bloodGroup: data.bloodGroup || "",
            nationalId: data.nationalId || "",
            personalEmail: data.personalEmail || "",
            officialEmail: data.officialEmail || "",
            phoneNumber: data.phoneNumber || "",
            address: data.address || "",
            city: data.city || "",
            postalCode: data.postalCode || "",
            jobTitle: data.jobTitle || "",
            department: data.department || "",
            saturation: data.saturation || "",
            startDate: data.startDate ? data.startDate.split("T")[0] : "",
            status: data.status || "",

            // EmployeeAddlData table
            maritalStatus: data.maritalStatus || "",
            nationality: data.nationality || "",
            religion: data.religion || "",
            passportNumber: data.passportNumber || "",
            drivingLicenseNumber: data.drivingLicenseNumber || "",
            profileImageUrl: data.profileImageUrl ? `${API_BASE_URL}/uploads/${data.profileImageUrl}` : "",
          });

        } else {
          console.warn("No data found for userId:", userId);
        }
      } catch (err) {
        console.error("Failed to fetch employee data:", err);
      }
    };

    fetchData();
  }, [userId]);

  useEffect(() => {

    const fetchgeneralMaster = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {
        
      });
      if (res.ok) {
        const data = await res.json();
        setGeneralMaster(data);
      }
    };
    fetchgeneralMaster();
 
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    // Reset the input value to allow re-uploading the same file
    e.target.value = null;
  
    try {
      Resizer.imageFileResizer(
        file,
        800,
        800,
        "JPEG",
        70,
        0,
        (resizedBlob) => {
          const previewUrl = URL.createObjectURL(resizedBlob); // For preview only
          const compressedFile = new File([resizedBlob], file.name, {
            type: "image/jpeg",
          });
  
          setFormData((prev) => ({
            ...prev,
            profileImage: compressedFile,
            profileImageUrl: previewUrl,
          }));
          setSelectedFile(compressedFile); // Important: Also update selectedFile for submission
        },
        "blob"
      );
    } catch (err) {
      console.error("Image resize error:", err);
    }
  };
  
  const handleRemoveImage = () => {
    setFormData((prev) => ({
      ...prev,
      profileImage: null,
      profileImageUrl: null,
    }));
    setSelectedFile(null);
  };
  

  const handleSubmit = async () => {
    const missing = requiredFields.filter((field) => {
      const value = formData[field.name];
    
      if (typeof value === "string") {
        return !value.trim();
      }
    
      return value === null || value === undefined || value === "";
    });
    

    if (missing.length > 0) {
      setNotification({
        type: "error",
        message:
          "Please fill all required fields: " +
          missing.map((f) => f.label).join(", "),
      });
      return;
    }

    const uploadData = new FormData();

    // Append all fields from formData
    for (const key in formData) {
      uploadData.append(key, formData[key]);
    }

    // Append image file (not URL)
    if (selectedFile) {
      uploadData.append("profileImage", selectedFile);
    }

    try {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/Employee/SaveEmployee`, {
        method: "POST",
        body: uploadData,
      });
      if (response.ok) {
        setNotification({
          type: "success",
          message: "Employee information saved successfully.",
        });
        // setFormData({});
      } else {
        const error = await response.text();
        setNotification({
          type: "error",
          message: "Error saving data: " + error,
        });
      }
    } catch (err) {
      setNotification({
        type: "error",
        message: "Network error: " + err.message,
      });
    } finally {
      setIsLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  const renderInput = (label, name, type = "text", options = null, readOnly = false) => (
    <div className="flex flex-col gap-1 py-2">
      <label className="text-[#111518] text-base font-medium leading-normal pb-2">
        {label}
        {requiredFields.some((f) => f.name === name) && (
          <span className="text-red-500">*</span>
        )}
      </label>
      {Array.isArray(options) && options.length > 0 ? (
        <select
          name={name}
          value={formData[name] || ""}
          onChange={handleChange}
          disabled={readOnly}
          className="form-input"
        >
          <option value="">Select {label.toLowerCase()}</option>
          {options.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.title}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={formData[name] || ""}
          disabled={readOnly}
          onChange={handleChange}
          placeholder={`Enter ${label.toLowerCase()}`}
          className="form-input"
        />
      )}
    </div>
  );

  return (
    <div className="px-4 py-6">
      <h2 className="text-[#111518] text-[22px] font-bold leading-tight tracking-[-0.015em] pb-3">
        Personal Information
      </h2>

      {notification && (
        <div
          className={`mb-4 px-4 py-3 rounded flex justify-between items-start ${notification.type === "error"
            ? "bg-red-100 text-red-700"
            : "bg-green-100 text-green-700"
            }`}
        >
          <span>{notification.message}</span>
          <button
            onClick={handleCloseNotification}
            className="ml-4 font-bold text-lg leading-none"
          >
            ×
          </button>
        </div>
      )}


<div className="flex flex-col items-center mb-6 gap-2">
  <div className="relative group w-32 h-32 border-1 border-black rounded-full shadow-md overflow-hidden">
    {formData.profileImageUrl ? (
      <img
        src={formData.profileImageUrl}
        alt="Profile"
        className="w-full h-full object-cover"
      />
    ) : (
      <div className="w-full h-full flex items-center justify-center text-sm text-gray-500 bg-gray-100">
        No Image
      </div>
    )}

    <label
      htmlFor="profileImage"
      className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 cursor-pointer transition-opacity duration-200"
      title="Change Image"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15.232 5.232l3.536 3.536M9 11l6-6 3 3-6 6H9v-3zM3 21h18"
        />
      </svg>
    </label>

    <input
      id="profileImage"
      type="file"
      accept="image/*"
      onChange={handleFileChange}
      className="hidden"
    />
  </div>

  {formData.profileImageUrl && (
    <button
      type="button"
      onClick={handleRemoveImage}
      title="Remove Image"
      className="flex items-center gap-1 text-red-600 hover:text-red-800 transition-colors text-sm"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        className="w-5 h-5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 
             2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22m-5 
             0V5a2 2 0 00-2-2H9a2 2 0 00-2 2v2"
        />
      </svg>
      <span className="hidden sm:inline">Remove</span>
    </button>
  )}
</div>




      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {renderInput("First Name", "firstName", "text", null, true)}
        {renderInput("Last Name", "lastName", "text", null, true)}
        {renderInput("Employee ID", "employeeID", "text", null, true)}
        {renderInput("Date of Birth", "dateOfBirth", "date", null, true)}
        {renderInput("Gender", "gender", "text", generalMaster.filter(gm => gm.mainId == 19), true)}
        {renderInput("Marital Status", "maritalStatus", "text", generalMaster.filter(gm => gm.mainId == 27))}
        {renderInput("Nationality", "nationality", "text",  generalMaster.filter(gm => gm.mainId == 32))}
        {renderInput("Religion", "religion")}
        {renderInput("Blood Group", "bloodGroup", "text",  generalMaster.filter(gm => gm.mainId == 34))}
        {renderInput("National ID Number", "nationalId")}
        {renderInput("Passport Number", "passportNumber")}
        {renderInput("Driving License Number", "drivingLicenseNumber")}
      </div>

      <div className="flex justify-end mt-6">
        <button
          onClick={handleSubmit}
          className="btn-black"
        >
          {
            isLoading ?
              <div className="flex justify-center"><Spinner animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} />Saving In...</div>
              :
              'Save'
          }

        </button>
      </div>
    </div>
  );
};

export default PersonalInfo;
